import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, industryActionId, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import Loader from '../../../utils/Loader';
import { get_master_list_action, delete_master_action } from '../../../actions/adminAction/master_action';
import { Tab, Nav, Modal } from "react-bootstrap";

class masterList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false, recordsPerPage: 10,
            Name: '', tabSelected: 'B', deleteModal: false, deleteID: '',
            statusId: '', ID: '', currentPage: 1, currentPage2: 1, currentPage3: 1, currentPage4: 1, masterList: [],
            FullAccessM: false, ReadAccessM: false, WriteAccessM: false, UpdateAccessM: false, DeleteAccessM: false, DownloadAccessM: false, Is_SpecialAccessM: false, SendAccessM: false,
            FullAccessB: false, ReadAccessB: false, WriteAccessB: false, UpdateAccessB: false, DeleteAccessB: false, DownloadAccessB: false, Is_SpecialAccessB: false, SendAccessB: false,
            FullAccessO: false, ReadAccessO: false, WriteAccessO: false, UpdateAccessO: false, DeleteAccessO: false, DownloadAccessO: false, Is_SpecialAccessO: false, SendAccessO: false,
            FullAccessE: false, ReadAccessE: false, WriteAccessE: false, UpdateAccessE: false, DeleteAccessE: false, DownloadAccessE: false, Is_SpecialAccessE: false, SendAccessE: false,
            FullAccessS: false, ReadAccessS: false, WriteAccessS: false, UpdateAccessS: false, DeleteAccessS: false, DownloadAccessS: false, Is_SpecialAccessS: false, SendAccessS: false,
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const masterListModule = loginAccessList.find(module => module.ModuleName === "Master");
            const businessSectorModule = loginAccessList.find(module => module.ModuleName === "Business Sector");
            const organisationModule = loginAccessList.find(module => module.ModuleName === "Organization Type");
            const enterpriseModule = loginAccessList.find(module => module.ModuleName === "Enterprise Type");
            const serviceModule = loginAccessList.find(module => module.ModuleName === "Service Type");
            if (masterListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = masterListModule;
                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login');
                } else {
                    this.setState({
                        //MASTER
                        FullAccessM: !!FullAccess,
                        ReadAccessM: !!ReadAccess,
                        WriteAccessM: !!WriteAccess,
                        UpdateAccessM: !!UpdateAccess,
                        DeleteAccessM: !!DeleteAccess,
                        DownloadAccessM: !!DownloadAccess,
                        Is_SpecialAccessM: !!Is_SpecialAccess,
                        SendAccessM: !!SendAccess,
                    });
                    //MASTER
                    if (FullAccess) {
                        this.setState({
                            ReadAccessM: true,
                            WriteAccessM: true,
                            UpdateAccessM: true,
                            DeleteAccessM: true,
                            DownloadAccessM: true,
                            Is_SpecialAccessM: true,
                            SendAccessM: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }
            if (businessSectorModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = businessSectorModule;
                this.setState({
                    FullAccessB: !!FullAccess,
                    ReadAccessB: !!ReadAccess,
                    WriteAccessB: !!WriteAccess,
                    UpdateAccessB: !!UpdateAccess,
                    DeleteAccessB: !!DeleteAccess,
                    DownloadAccessB: !!DownloadAccess,
                    Is_SpecialAccessB: !!Is_SpecialAccess,
                    SendAccessB: !!SendAccess,
                })
                if (FullAccess) {
                    this.setState({
                        ReadAccessB: true,
                        WriteAccessB: true,
                        UpdateAccessB: true,
                        DeleteAccessB: true,
                        DownloadAccessB: true,
                        Is_SpecialAccessB: true,
                        SendAccessB: true
                    });
                }
            }
            if (organisationModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = organisationModule;
                this.setState({
                    FullAccessO: !!FullAccess,
                    ReadAccessO: !!ReadAccess,
                    WriteAccessO: !!WriteAccess,
                    UpdateAccessO: !!UpdateAccess,
                    DeleteAccessO: !!DeleteAccess,
                    DownloadAccessO: !!DownloadAccess,
                    Is_SpecialAccessO: !!Is_SpecialAccess,
                    SendAccessO: !!SendAccess,
                })
                if (FullAccess) {
                    this.setState({
                        ReadAccessO: true,
                        WriteAccessO: true,
                        UpdateAccessO: true,
                        DeleteAccessO: true,
                        DownloadAccessO: true,
                        Is_SpecialAccessO: true,
                        SendAccessO: true
                    });
                }
            }
            if (enterpriseModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = enterpriseModule;
                this.setState({
                    FullAccessE: !!FullAccess,
                    ReadAccessE: !!ReadAccess,
                    WriteAccessE: !!WriteAccess,
                    UpdateAccessE: !!UpdateAccess,
                    DeleteAccessE: !!DeleteAccess,
                    DownloadAccessE: !!DownloadAccess,
                    Is_SpecialAccessE: !!Is_SpecialAccess,
                    SendAccessE: !!SendAccess,
                })
                if (FullAccess) {
                    this.setState({
                        ReadAccessE: true,
                        WriteAccessE: true,
                        UpdateAccessE: true,
                        DeleteAccessE: true,
                        DownloadAccessE: true,
                        Is_SpecialAccessE: true,
                        SendAccessE: true
                    });
                }
            }
            if (serviceModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = serviceModule;
                this.setState({
                    FullAccessS: !!FullAccess,
                    ReadAccessS: !!ReadAccess,
                    WriteAccessS: !!WriteAccess,
                    UpdateAccessS: !!UpdateAccess,
                    DeleteAccessS: !!DeleteAccess,
                    DownloadAccessS: !!DownloadAccess,
                    Is_SpecialAccessS: !!Is_SpecialAccess,
                    SendAccessS: !!SendAccess,
                })
                if (FullAccess) {
                    this.setState({
                        ReadAccessS: true,
                        WriteAccessS: true,
                        UpdateAccessS: true,
                        DeleteAccessS: true,
                        DownloadAccessS: true,
                        Is_SpecialAccessS: true,
                        SendAccessS: true
                    });
                }
            }
            if (loginAccessList.length) {
                setTimeout(() => {
                    this.getMasterList()
                }, 500);
            }
        }
    }

    getMasterList() {
        const { Name, statusId, tabSelected } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_master_list_action(Name, statusId, tabSelected)
            .then((data) => {
                console.log(data.data)
                if (data.error != 1) {
                    this.setState({ isLoading: false, masterList: data.data })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    navMasterDetailsView(id, type, tabSelected) {
        this.props.navigate('/master_detail', {
            state: {
                ID: id, navType: type, tabSelected: tabSelected
            }
        })
    }
    deleteMaster(id) {
        const { tabSelected } = this.state;
        this.setState({ isLoading: true })
        this.props
            .delete_master_action(id, tabSelected)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false, deleteModal: false, deleteID: '' }, () => toastSuccess('Coupon Deleted Successfully'))
                    setTimeout(() => {
                        this.getMasterList()
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    updateItem = (item) => {
        this.setState({ currentPage: item });
    };

    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };

    masterRecord(masterList) {
        const { tabSelected, ReadAccessB, UpdateAccessB, DeleteAccessB, ReadAccessO, UpdateAccessO, DeleteAccessO,
            ReadAccessE, UpdateAccessE, DeleteAccessE, ReadAccessS, UpdateAccessS, DeleteAccessS, } = this.state
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th className='text-center'>Action</th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {masterList?.length > 0 ? masterList?.map((data) => (
                        <tr>
                            <td>{data.Name}</td>
                            <td>{data.Status}</td>
                            <td className="text-center" style={{ width: '10%' }}>
                                {((tabSelected == 'B' && ReadAccessB) || (tabSelected == 'E' && ReadAccessE) || (tabSelected == 'O' && ReadAccessO) || (tabSelected == 'S' && ReadAccessS)) && (
                                    <a
                                        onClick={() => this.navMasterDetailsView(data.ID, 1, tabSelected)}
                                        title="View Details"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-eye" />
                                    </a>
                                )}
                                {((tabSelected == 'B' && UpdateAccessB) || (tabSelected == 'E' && UpdateAccessE) || (tabSelected == 'O' && UpdateAccessO) || (tabSelected == 'S' && UpdateAccessS)) && (
                                    <a
                                        onClick={() => this.navMasterDetailsView(data.ID, 2, tabSelected)}
                                        title="Edit Details"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-pencil" />
                                    </a>)}
                                {((tabSelected == 'B' && DeleteAccessB) || (tabSelected == 'E' && DeleteAccessE) || (tabSelected == 'O' && DeleteAccessO) || (tabSelected == 'S' && DeleteAccessS)) && (
                                    <a
                                        onClick={() => this.setState({ deleteModal: true, deleteID: data.ID })}
                                        title="Delete"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-trash" />
                                    </a>)}
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={10}>No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    render() {
        const { isLoading, masterList, Name, currentPage, isFilterShow, statusId, tabSelected, deleteModal, deleteID, recordsPerPage,
            WriteAccessM, ReadAccessB, WriteAccessB, ReadAccessO, WriteAccessO, ReadAccessE, WriteAccessE, ReadAccessS, WriteAccessS,
        } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = masterList?.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(masterList?.length / recordsPerPage);
        return (
            <>
                {isLoading ? (<Loader></Loader>) : (null)}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">

                                            <div className="card shadow-none border">

                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                <Tab.Container defaultActiveKey="B">
                                                                    <Nav variant="tabs" role="tablist"
                                                                        className="nav nav-tabs nav-tabs-custom nav-success mb-3">
                                                                        {ReadAccessB && (
                                                                            <Nav.Item>
                                                                                <Nav.Link eventKey="B"
                                                                                    onClick={() => this.setState({ currentPage: 1, tabSelected: 'B' }, () => this.getMasterList())}
                                                                                >Business Sector
                                                                                </Nav.Link>
                                                                            </Nav.Item>
                                                                        )}
                                                                        {ReadAccessO && (
                                                                            <Nav.Item>
                                                                                <Nav.Link eventKey="O"
                                                                                    onClick={() => this.setState({ currentPage2: 1, tabSelected: 'O' }, () => this.getMasterList())}
                                                                                >Organization Type
                                                                                </Nav.Link>
                                                                            </Nav.Item>)}
                                                                        {ReadAccessE && (
                                                                            <Nav.Item>
                                                                                <Nav.Link eventKey="E"
                                                                                    onClick={() => this.setState({ currentPage3: 1, tabSelected: 'E' }, () => this.getMasterList())}
                                                                                >Enterprise Type
                                                                                </Nav.Link>
                                                                            </Nav.Item>)}
                                                                        {ReadAccessS && (
                                                                            <Nav.Item>
                                                                                <Nav.Link eventKey="S"
                                                                                    onClick={() => this.setState({ currentPage4: 1, tabSelected: 'S' }, () => this.getMasterList())}
                                                                                >Service Type
                                                                                </Nav.Link>
                                                                            </Nav.Item>)}
                                                                    </Nav>
                                                                    <div className="card shadow-none border mb-2" >
                                                                        <div className="card-header py-1">
                                                                            <h6 className='pt-2' style={{ float: 'left' }}>Master List</h6>
                                                                            {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                                                {(ReadAccessB || ReadAccessO || ReadAccessE || ReadAccessS) && <a style={{ float: 'right' }}
                                                                                    href="javascript:void(0);"
                                                                                    className="btn btn-purple custom_btn"
                                                                                    title="Filter"
                                                                                    data-toggle="modal"
                                                                                    data-target="#filter_modal"
                                                                                    onClick={() => this.toggleFilterCollapse()}
                                                                                >
                                                                                    <i className="fa fa-filter" />
                                                                                </a>}
                                                                                {WriteAccessM && (
                                                                                    <div class="btn-group" style={{ float: 'right' }}>
                                                                                        <button type="button" class="btn btn-outline-primary" onClick={() => this.navMasterDetailsView(null, 3, tabSelected)} aria-expanded="false">
                                                                                            Add
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </> : <></>}
                                                                        </div>
                                                                        <ul className="list-group list-group-flush">
                                                                            {isFilterShow && <>
                                                                                <li className="list-group-item">
                                                                                    <div className="row ">
                                                                                        <div className="col-xl-2 mb-2">
                                                                                            <div class="form-group">
                                                                                                <label>Name</label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    defaultValue=""
                                                                                                    value={Name}
                                                                                                    // onKeyDown={e => this.handleKeyDown(e)}
                                                                                                    onChange={(e) => this.setState({ Name: e.target.value })}
                                                                                                />
                                                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-xl-2 mb-2">
                                                                                            <div class="form-group">
                                                                                                <label>Status</label>
                                                                                                <select className="form-control" value={statusId} id="privileges" onChange={(e) => this.setState({ statusId: e.target.value })}>
                                                                                                    <option value={''}>Select</option>
                                                                                                    <option value={1}>Active</option>
                                                                                                    <option value={0}>InActive</option>
                                                                                                </select>
                                                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-xl-2 mb-3">
                                                                                            < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getMasterList()}>
                                                                                                Search
                                                                                            </button>
                                                                                            <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark  mr-2 ms-2' onClick={() => this.setState({
                                                                                                disPer: '', Name: '', expiry: '', statusId: 1
                                                                                            }, () => { this.getMasterList() })}>
                                                                                                Clear
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            </>}
                                                                        </ul>
                                                                    </div>
                                                                    <Tab.Content>
                                                                        {/* All Orders Tab */}
                                                                        {ReadAccessB && (
                                                                            <Tab.Pane eventKey="B">
                                                                                {this.masterRecord(currentRecords)}
                                                                                {masterList?.length > 0 ? (
                                                                                    <Pagination nPages={nPages}
                                                                                        currentPage={currentPage}
                                                                                        setCurrentPage={this.updateItem}
                                                                                        totalRecords={masterList?.length}
                                                                                        pageLength={recordsPerPage}
                                                                                        setPageLength={this.updateRecordsPerPage}
                                                                                    />
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </Tab.Pane>)}
                                                                        {ReadAccessO && (
                                                                            <Tab.Pane eventKey="O">
                                                                                {this.masterRecord(currentRecords)}
                                                                                {masterList?.length > 0 ? (
                                                                                    <Pagination nPages={nPages}
                                                                                        currentPage={currentPage}
                                                                                        setCurrentPage={this.updateItem}
                                                                                        totalRecords={masterList?.length}
                                                                                        pageLength={recordsPerPage}
                                                                                        setPageLength={this.updateRecordsPerPage}
                                                                                    />
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </Tab.Pane>)}
                                                                        {ReadAccessE && (
                                                                            <Tab.Pane eventKey="E">
                                                                                {this.masterRecord(currentRecords)}
                                                                                {masterList?.length > 0 ? (
                                                                                    <Pagination nPages={nPages}
                                                                                        currentPage={currentPage}
                                                                                        setCurrentPage={this.updateItem}
                                                                                        totalRecords={masterList?.length}
                                                                                        pageLength={recordsPerPage}
                                                                                        setPageLength={this.updateRecordsPerPage}
                                                                                    />
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </Tab.Pane>)}
                                                                        {ReadAccessS && (
                                                                            <Tab.Pane eventKey="S">
                                                                                {this.masterRecord(currentRecords)}
                                                                                {masterList?.length > 0 ? (
                                                                                    <Pagination nPages={nPages}
                                                                                        currentPage={currentPage}
                                                                                        setCurrentPage={this.updateItem}
                                                                                        totalRecords={masterList?.length}
                                                                                        pageLength={recordsPerPage}
                                                                                        setPageLength={this.updateRecordsPerPage}
                                                                                    />
                                                                                ) : (
                                                                                    <></>
                                                                                )}
                                                                            </Tab.Pane>)}
                                                                    </Tab.Content>
                                                                </Tab.Container>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <Modal show={deleteModal} onHide={() => this.setState({ deleteModal: false })}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body><p class="pop_label">Do you really want to delete this Record?</p></Modal.Body>
                                <Modal.Footer>
                                    <button type="button" class="btn btn-success"
                                        onClick={(e) => this.deleteMaster(deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ deleteModal: false, deleteID: '' })}>No</button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div >
                </section >
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_master_list_action, delete_master_action })(masterList));
